import { Component, ViewEncapsulation } from '@angular/core';

export interface Environment {
  GRAPHQL_URI: string;
  RECAPTCHA_SITEKEY: string;
  GOOGLE_MAPS_API_KEY: string;
  SUPPRESS_RECAPTCHA: boolean;
  APP_JSON_S3_BUCKET_URL: string;
  ADOBE_SCRIPT_URL: string;
  GOOGLE_TAG_MANAGER_ID: string;
  GOOGLE_ANALYTICS_ID: string;
  FULLSTORY_ID: string;
  LAUNCH_DARKLY_CLIENT_ID: string;
}

declare global {
  let prequalConfig: Environment;
}

@Component({
  selector: 'capq-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class AppComponent {}
